const SpAuthenticationFailedError = function(message, nextState, auth) {
  this.nextState = nextState
  this.message = message
  this.auth = auth
}

SpAuthenticationFailedError.prototype = Object.create(Error.prototype)
SpAuthenticationFailedError.prototype.constructor = SpAuthenticationFailedError

export default SpAuthenticationFailedError


/** WEBPACK FOOTER **
 ** ./components/service-provider/sp-authentication-failed-error.js
 **/